/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
  Box,
  VStack,
  Text,
} from '@mybridge/ui';
import { css, keyframes } from '@emotion/react';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAiSuggestedIntro,
  clearSuggestion,
  setInfoPermissions,
  setAccountPermissions,
  getUserProfileInfo,
} from 'v4/store/actions/user-profile.actions';
import {
  CallLockIcon,
  EarthGlobeIcon,
  LockIcon,
  OnlyMeLockIcon,
  Security,
  TeamIcon,
} from '@mybridge/icons';
import _ from 'lodash';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const AudienceFriendsListModal = forwardRef(({ ...props }, ref) => {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const [radioValue, setRadioValue] = useState(_.get(
    userProfileInfo,
    'field_audience_visibility.WHO_CAN_SEE_FRIENDS'
  ) ?? 1);

  const slideUpAnimation = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;
  const onSubmit = () => {
    const payload = {
      attribute: 'WHO_CAN_SEE_FRIENDS', // WHO_CAN_SEND_FRIEND_REQ | WHO_CAN_SEE_FRIENDS | MENTIONS_AND_TAGS
      audience: Number(radioValue),
    };
    dispatch(setAccountPermissions(payload)).then((res) => {
      if(res?.payload){
        dispatch(getUserProfileInfo());
        props.onClose();
    }
  });
  };

  return (
    <>
    {isMobile&&(  <Modal isCentered size="xl" {...(props ?? {})}>
        <ModalOverlay width="800px" />
        <ModalContent
          position="fixed"
          bottom="0"
          left="0"
          right="0"
          borderRadius="40px 40px 0 0"
          animation={`${slideUpAnimation} 0.3s ease-in-out`}
        >
          <ModalHeader
            textAlign="center"
            fontWeight="500"
            fontSize="Inter"
            color="#5B5B5B"
            lineHeight="20px"
          >
            {t('settingsAudience.whoCanSeeFriendList') || "Who can see your friend list?"}
          </ModalHeader>
          <ModalBody>
            <RadioGroup onChange={setRadioValue} value={Number(radioValue)}>
              <VStack gap={3} align="stretch">
                <HStack justifyContent="space-between">
                  <HStack>
                    <Stack
                      w="40px"
                      h="40px"
                      borderRadius="100%"
                      bg="#D9D9D9"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <EarthGlobeIcon width="13.47px" height="13.47px" />
                    </Stack>
                    <VStack alignItems="flex-start" gap="0">
                      <Text
                        font="Inter"
                        fontSize="15px"
                        fontWeight="400"
                        color="#747474"
                        lineHeight="30px"
                      >
                        1<sup>st</sup> Degree
                      </Text>
                      <Text
                        color="#747474"
                        fontSize="10px"
                        fontWeight={400}
                        lineHeight="14px"
                      >
                        {t('settingsAudience.connectedPeople') || "People who are connected to you"}{' '}
                      </Text>
                    </VStack>
                  </HStack>
                  <Radio value={1} />
                </HStack>
                {/* <HStack justifyContent="space-between">
                  <HStack>
                    <Stack
                      w="50px"
                      h="50px"
                      borderRadius="50%"
                      bg="#D9D9D9"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <TeamIcon color="#5B5B5B" />
                    </Stack>
                    <VStack alignItems="flex-start" gap="0">
                      <Text
                        fontSize="18px"
                        fontWeight="600"
                        color="brandPrimary.500"
                      >
                        myNetwork
                      </Text>
                      <Text>
                        Your networks on myBridge, including 2nd and 3rd
                        degrees.
                      </Text>
                    </VStack>
                  </HStack>
                  <Radio value={2} />
                </HStack> */}
                <HStack justifyContent="space-between">
                  <HStack>
                    <Stack
                      w="40px"
                      h="40px"
                      borderRadius="100%"
                      bg="#D9D9D9"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <OnlyMeLockIcon width="16px" height="16px" />
                    </Stack>
                    <VStack alignItems="flex-start" gap="0">
                      <Text
                        font="Inter"
                        fontSize="15px"
                        fontWeight="400"
                        color="#747474"
                        lineHeight="30px"
                      >
                        {t('profileDetails.onlyMe') || 'Only me'}
                      </Text>
                      {/* <Text>Anyone on or off myBridge</Text> */}
                    </VStack>
                  </HStack>
                  <Radio value={2} />
                </HStack>
              </VStack>
            </RadioGroup>
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button
                onClick={() => {
                  props?.onClose();
                }}
                fontWeight={600}
                borderRadius="30px"
                bgColor="#E7E8ED"
                color="#4F4F4F"
              >
                {t('buttons.cancel') || "Cancel"}
              </Button>
              <Button
                borderRadius="30px"
                bgColor="#3D5A80"
                color="#FFFFFF"
                fontSize="16px"
                fontWeight={600}
                variant="primary"
                onClick={() => onSubmit()}
              >
                {t('buttons.done') || "Done"}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>)}

      {!isMobile&&(

<Modal size="xl" {...(props ?? {})}>
<ModalOverlay />
<ModalContent>
  <ModalHeader
    borderBottom="1px solid #ddd"
    textAlign="center"
    fontWeight="400"
  >
    {t('settingsAudience.whoCanSeeFriendList') || "Who can see your friend list?"}
    <ModalCloseButton />
  </ModalHeader>
  <ModalBody>
    <RadioGroup onChange={setRadioValue} value={Number(radioValue)}>
      <VStack gap={3} align="stretch">
        <HStack justifyContent="space-between">
          <HStack>
            <Stack
              w="50px"
              h="50px"
              borderRadius="50%"
              bg="#D9D9D9"
              alignItems="center"
              justifyContent="center"
            >
              <EarthGlobeIcon />
            </Stack>
            <VStack alignItems="flex-start" gap="0">
              <Text
                fontSize="18px"
                fontWeight="600"
                color="brandPrimary.500"
              >
                1<sup>st</sup> {t('profileNetwork.degree') || "Degree"}
              </Text>
              <Text>{t('settingsAudience.connectedPeople') || "People who are connected to you"} </Text>
            </VStack>
          </HStack>
          <Radio value={1} />
        </HStack>
        {/* <HStack justifyContent="space-between">
          <HStack>
            <Stack
              w="50px"
              h="50px"
              borderRadius="50%"
              bg="#D9D9D9"
              alignItems="center"
              justifyContent="center"
            >
              <TeamIcon color="#5B5B5B" />
            </Stack>
            <VStack alignItems="flex-start" gap="0">
              <Text
                fontSize="18px"
                fontWeight="600"
                color="brandPrimary.500"
              >
                myNetwork
              </Text>
              <Text>
                Your networks on myBridge, including 2nd and 3rd
                degrees.
              </Text>
            </VStack>
          </HStack>
          <Radio value={2} />
        </HStack> */}
        <HStack justifyContent="space-between">
          <HStack>
            <Stack
              w="50px"
              h="50px"
              borderRadius="50%"
              bg="#D9D9D9"
              alignItems="center"
              justifyContent="center"
            >
              <OnlyMeLockIcon />
            </Stack>
            <VStack alignItems="flex-start" gap="0">
              <Text
                fontSize="18px"
                fontWeight="600"
                color="brandPrimary.500"
              >
                {t('profileDetails.onlyMe') || 'Only me'}
              </Text>
              {/* <Text>Anyone on or off myBridge</Text> */}
            </VStack>
          </HStack>
          <Radio value={2} />
        </HStack>
      </VStack>
    </RadioGroup>
  </ModalBody>
  <ModalFooter borderTop="1px solid #ddd">
    <HStack>
      <Button
        borderRadius="30px"
        onClick={() => {
          props?.onClose();
        }}
      >
        {t('buttons.cancel') || "Cancel"}
      </Button>
      <Button borderRadius="30px" variant="primary" onClick={() => onSubmit()}>
        {t('buttons.done') || "Done"}
      </Button>
    </HStack>
  </ModalFooter>
</ModalContent>
</Modal>
      )}
    </>
  );
});
